import { Button, IconButton, Typography } from "@material-ui/core";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { decryptData } from "../../../../crypto";
import useStyles from "../../../../styles";
import QuestionHead from "../../../CustomComponent/QuestionHead";
import ResultHead from "../../../CustomComponent/ResultHead1";
import Loader from "../../../CustomComponent/Loader";
import TableView from "../../../CustomComponent/TableView";
import { ReactComponent as ResultIcon } from "../../../images/questionimage/resulticon.svg";

function ExamFeedbackResult() {
  const classes = useStyles();
  const { rowId } = useParams();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);
  const [fileURL, setFileURL] = useState("");
  const navigate = useNavigate();
  const params = useParams();

  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);

  const [page, setPage] = useState(0);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage) // Pass newSelection directly
  };

  const [rowCount, setRowCount] = useState("");

  const [examDetails, setExamDetails] = useState({
    examName: "",
    courseName: "",
    batchName: "",
    subjectNames: "",
    examImage: "",
  });

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        );

        const exam = response.data.exam;
        const subjectNames = exam.subjects
          .map((sub) => sub.subject_name)
          .join(", ");

        setExamDetails({
          examName: exam.exam_name,
          courseName: exam.course.map((c) => c?.course_name).join(", "),
          batchName: exam.batch.map((c) => c?.batch_name).join(", "),
          subjectNames: subjectNames,
          examImage: exam.image_url,
        });
      } catch (error) {
        console.error("Error fetching exam data: ", error);
      }
    };

    fetchExamData();
  }, [rowId, decryptedToken]);

  const fetchData = async (rowId, pageNumber, size, search) => {
    if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/result/${rowId}?page=${pageNumber + 1}&limit=${size}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      setResults(response.data.exam_results);
      setRowCount(response.data.total_count)
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  useEffect(() => {
    if (onPage !== undefined && pageSize !== undefined && searchQuery !== undefined) {
      fetchData(rowId, onPage, pageSize, searchQuery);
    }
  }, [rowId, onPage, pageSize, searchQuery]);

  // const exportResultApi = async (rowId) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/export/${rowId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${decryptedToken}`,
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       // toast.success("Result CSV has been downloaded successfully.");
  //       setFileURL(response.data.file_url);
  //     } else {
  //       // toast.error("Failed to download the CSV file.");
  //     }
  //   } catch (error) {
  //     const errorMessage = error.response && error.response.data.message ? error.response.data.message : "An error occurred while fetching the data.";
  //     // toast.error(errorMessage);
  //   }
  // };
  // useEffect(() => {
  //   exportResultApi(rowId);
  // }, [rowId]);

  const navigateToAnswer = async (userId, student_name) => {
    console.log(userId);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/result/${rowId}`,
        {
          user_id: userId,
        },
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      console.log(response);
      if (response.data.success === true) {
        const examResult = response.data;
        navigate(`/admin/examfeedbackresult/:${params.rowId}/examscore`, {
          state: {
            examResult: JSON.stringify(examResult),
            studentName: student_name,
            examName: examDetails.examName,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const rows = results.map((d) => ({
    id: d.id ? d.id : "N/A",
    student_name: d.student_name ? d.student_name : "N/A",
    roll_number: d.roll_number ? d.roll_number : "N/A",
    center_code: `${d.center_code || "N/A"} - ${d.center_name || "N/A"}`,
    phone: d.phone ? d.phone : "N/A",
    received_marks:
      d.received_marks !== null && d.received_marks !== undefined
        ? d.received_marks
        : "N/A",

    correct_answer:
      d.correct_answer !== null && d.correct_answer !== undefined
        ? d.correct_answer
        : "N/A",
    incorrect_answer:
      d.incorrect_answer !== null && d.incorrect_answer !== undefined
        ? d.incorrect_answer
        : "N/A",
    user_id: d.user_id,

    email: d.email ? d.email : "N/A",
    total_score: d.total_score ? d.total_score : "N/A",
    total_questions: d.total_questions ? d.total_questions : "N/A",
    active_status: d.active_status ? d.active_status : "N/A",
  }));
  const startIndex = onPage * pageSize;
  const filteredRows = rows.map((row, index) => ({
    ...row,
    srno: startIndex + index + 1,
  }));

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const Result = [
    {
      id: 1,
      pageicon: <ResultIcon />,
      mainheading: "Students Results",
      searchlabel: "Search By Student Name",
      placeholder: "Search By Class",
      report1: "report01",
      report2: "report02",
      report3: "report03",
      report4: "report04",
      report5: "report05",
      report6: "report06",
      height: 'maxh67',
      style: "viewtable",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server"
    },
  ];
  const columns = [
    {
      field: "srno",
      headerName: "Sr.No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "roll_number",
      headerName: "Roll Number",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "student_name",
      headerName: "Student Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "phone",
    //   headerName: "Phone",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 200,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "center_code",
      headerName: "Branch Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "total_questions",
      headerName: "Total Questions",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "correct_answer",
      headerName: "Correct Answers",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "incorrect_answer",
      headerName: "Incorrect Answers",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "received_marks",
      headerName: "Recieved Marks",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "active_status",
      headerName: "View Result",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 100,
      autoPageSize: false,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              startIcon={<DownloadIcon color="success" />}
              onClick={() =>
                navigateToAnswer(params.row.user_id, params.row.student_name)
              }
            />
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      logo: examDetails.examImage,
      path: "/admin/feedback",
      headings: [
        {
          id: 11,
          label: "Name",
          content: examDetails.examName,
        },
        // {
        //   id: 12,
        //   label: "Subject",
        //   content: examDetails.subjectNames,
        // },
        {
          id: 13,
          label: "Course",
          content: examDetails.courseName,
        },
        {
          id: 14,
          label: "Batch",
          content: examDetails.batchName,
        },
      ],
    },
  ];

  const [loaderOpen, setLoaderOpen] = useState(false);


  return (
    <>
      <ToastContainer />
      <div className={`${classes.p2} ${classes.pb0} ${classes.pt1} ${classes.pagescroll} ${classes.h90vh}`}>
        <QuestionHead Heading={Heading} />
        <div className={`${classes.mt1}`}>
          <Loader loaderOpen={loaderOpen} />
          <ResultHead
            result={true}
            rowId={rowId}
            decryptedToken={decryptedToken}
            onSearch={handleSearch}
            Heading={Result}
            setLoaderOpen={setLoaderOpen}
            searchQuery={searchQuery}
          />
          <TableView columns={columns} rows={filteredRows} Heading={Result} />
        </div>
      </div>
    </>
  );
}
export default ExamFeedbackResult;

